import type { TrackingConfig } from './types';
import { DEFAULT_SUPPORT_COUNTRIES } from './constants';
import { parseQueryFromHref } from './query';
import {
  stripReferrerAndUtmTags,
  getSelectedCountryPath,
  buildTrackUrl,
  getBaseUrlFromHost,
} from './url';

export async function runTracking(config?: TrackingConfig): Promise<void> {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const supportCountries = config?.supportCountries ?? DEFAULT_SUPPORT_COUNTRIES;
  const baseUrl =
    config?.baseUrl ?? getBaseUrlFromHost(window.location.hostname);

  const selectedCountry = getSelectedCountryPath(
    window.location.hostname,
    window.location.pathname,
    supportCountries,
  );
  const url = buildTrackUrl(baseUrl, selectedCountry);
  const parsedUrl = new URL(url);

  const vars = parseQueryFromHref(window.location.href);
  const docReferrer = stripReferrerAndUtmTags(document.referrer);
  const externalReferrer =
    typeof localStorage !== 'undefined' ? localStorage.getItem('external_referrer') : null;
  const referrer =
    externalReferrer && externalReferrer !== docReferrer ? externalReferrer : docReferrer;
  const landingPage = stripReferrerAndUtmTags(window.location.href);

  const args: Record<string, string | undefined> = {
    l: vars['l'],
    utm_source: vars['utm_source'],
    utm_medium: vars['utm_medium'],
    utm_campaign: vars['utm_campaign'],
    utm_term: vars['utm_term'],
    utm_content: vars['utm_content'],
    utm_matchtype: vars['utm_matchtype'],
    utm_placement: vars['utm_placement'],
    utm_adposition: vars['utm_adposition'],
    utm_device: vars['utm_device'],
    utm_devicemodel: vars['utm_devicemodel'],
    gclid: vars['gclid'],
    fbclid: vars['fbclid'],
    referrer,
    landing_page: landingPage,
  };

  for (const [key, value] of Object.entries(args)) {
    if (value != null && value !== '') {
      parsedUrl.searchParams.append(key, value);
    }
  }

  await fetch(parsedUrl.toString(), { credentials: 'include' });

  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('external_referrer');
  }
}
